// import { useState, useRef, useEffect } from "react";
// import { useSelector, useDispatch } from "react-redux";
// import {
//   fetchProductsAll,
//   fetchProducts,
//   clearSearchResults,
// } from "../../../function/productsSlice";
// import { addFilter, removeFilter } from "../../../function/filtersSlice";
// import { auth, db } from "../../../firebase";
// import { query, getDocs, collection } from "firebase/firestore";
// import { Link, useNavigate } from "react-router-dom";

// export default function FilterMenu({
//   windowDimensions,
//   setAllBooks,
//   allBooks,
//   setIsBooksFilterActive,
// }) {
//   const [selectedFilters, setSelectedFilters] = useState([]);
//   const [objFilter, setObjFilter] = useState([]);
//   const dispatch = useDispatch();
//   const navigate = useNavigate();
//   const menuRef = useRef(null); // Ref для меню

//   useEffect(() => {
//     const fetchFilters = async () => {
//       const querySnapshot = await getDocs(collection(db, "filters"));
//       const loadedFilters = querySnapshot.docs.map((doc) => doc.data());
//       setObjFilter(loadedFilters);
//     };
//     fetchFilters();
//   }, []);

//   useEffect(() => {
//     dispatch(fetchProducts(selectedFilters));
//   }, [selectedFilters]);
//   const normalizeValueToString = (val) => {
//     if (val === true) return "true";
//     if (val === false) return "false";
//     return String(val);
//   };
//   // const handleFilterClickst = (filter) => {
//   //   const normalizedFilter = {
//   //     ...filter,
//   //     value: filter.value === "true" ? true : filter.value,
//   //   };

//   //   setSelectedFilters((prevFilters) => {
//   //     const index = prevFilters.findIndex(
//   //       (selectedFilter) =>
//   //         selectedFilter.field === normalizedFilter.field &&
//   //         selectedFilter.value === normalizedFilter.value
//   //     );

//   //     if (index === -1) {
//   //       return [...prevFilters, normalizedFilter];
//   //     } else {
//   //       return [
//   //         ...prevFilters.slice(0, index),
//   //         ...prevFilters.slice(index + 1),
//   //       ];
//   //     }
//   //   });
//   // };
//   const handleFilterClickst = (filter) => {
//     const normalizedFilter = {
//       ...filter,
//       value: normalizeValueToString(filter.value),
//     };

//     setSelectedFilters((prevFilters) => {
//       const index = prevFilters.findIndex(
//         (selectedFilter) =>
//           selectedFilter.field === normalizedFilter.field &&
//           selectedFilter.value === normalizedFilter.value
//       );

//       if (index === -1) {
//         return [...prevFilters, normalizedFilter];
//       } else {
//         return [
//           ...prevFilters.slice(0, index),
//           ...prevFilters.slice(index + 1),
//         ];
//       }
//     });
//   };
//   const filters = useSelector((state) => state.filters);

//   // const handleFilterClick = (filter) => {
//   //   if (
//   //     filters.some(
//   //       (selectedFilter) =>
//   //         selectedFilter.field === filter.field &&
//   //         selectedFilter.value === filter.value
//   //     )
//   //   ) {
//   //     dispatch(removeFilter(filter));
//   //   } else {
//   //     dispatch(addFilter(filter));
//   //   }
//   // };
//   // const handleFilterClick = (filter) => {
//   //   const normalizedFilter = {
//   //     ...filter,
//   //     value: filter.value === "true" ? true : filter.value,
//   //   };

//   //   if (
//   //     filters.some(
//   //       (selectedFilter) =>
//   //         selectedFilter.field === normalizedFilter.field &&
//   //         selectedFilter.value === normalizedFilter.value
//   //     )
//   //   ) {
//   //     dispatch(removeFilter(normalizedFilter));
//   //   } else {
//   //     dispatch(addFilter(normalizedFilter));
//   //   }
//   // };
//   const handleFilterClick = (filter) => {
//     const normalizedFilter = {
//       ...filter,
//       value: normalizeValueToString(filter.value),
//     };

//     if (
//       filters.some(
//         (selectedFilter) =>
//           selectedFilter.field === normalizedFilter.field &&
//           selectedFilter.value === normalizedFilter.value
//       )
//     ) {
//       dispatch(removeFilter(normalizedFilter));
//     } else {
//       dispatch(addFilter(normalizedFilter));
//     }
//   };

//   const closeMenu = () => {
//     setAllBooks(false);
//     navigate("/catalog");
//   };

//   const allBooksClose = () => {
//     dispatch(clearSearchResults());
//     dispatch(fetchProductsAll());
//     setAllBooks(false);
//     navigate("/catalog");
//   };

//   // Функція для обробки кліку поза меню
//   const handleClickOutside = (event) => {
//     if (menuRef.current && !menuRef.current.contains(event.target)) {
//       setAllBooks(false);
//       setIsBooksFilterActive(false);
//     }
//   };

//   useEffect(() => {
//     // Додаємо слухач кліків по документу
//     document.addEventListener("mousedown", handleClickOutside);
//     return () => {
//       // Очищуємо слухач кліків при демонтажі компонента
//       document.removeEventListener("mousedown", handleClickOutside);
//     };
//   }, []);

//   return (
//     <>
//       {objFilter && (
//         <div className="filterMenuWrapHeadr" ref={menuRef}>
//           <div className="secondBlockWrapFilterProd">
//             <ul className="ulFirstfilter">
//               <li className="ulFirstfilterLi">
//                 <div
//                   className={`blockCheckFilterJoin ${
//                     filters.some(
//                       (selectedFilter) =>
//                         selectedFilter.field === "predprodag" &&
//                         selectedFilter.value === "Предпродаж"
//                     )
//                       ? "selected"
//                       : ""
//                   }`}
//                   onClick={() => {
//                     handleFilterClick({
//                       field: "predprodag",
//                       value: "Предпродаж",
//                     });
//                     handleFilterClickst({
//                       field: "predprodag",
//                       value: "Предпродаж",
//                     });
//                   }}
//                 ></div>
//                 Передпродаж
//               </li>
//               <li className="ulFirstfilterLi">
//                 <div
//                   className={`blockCheckFilterJoin ${
//                     filters.some(
//                       (selectedFilter) =>
//                         selectedFilter.field === "isNew" &&
//                         selectedFilter.value === "Новинка"
//                     )
//                       ? "selected"
//                       : ""
//                   }`}
//                   onClick={() => {
//                     handleFilterClick({ field: "isNew", value: "Новинка" });
//                     handleFilterClickst({
//                       field: "isNew",
//                       value: "Новинка",
//                     });
//                   }}
//                 ></div>
//                 Новинка
//               </li>
//               <li className="ulFirstfilterLi">
//                 <div
//                   className={`blockCheckFilterJoin ${
//                     filters.some(
//                       (selectedFilter) =>
//                         selectedFilter.field === "sale" &&
//                         selectedFilter.value === "true"
//                     )
//                       ? "selected"
//                       : ""
//                   }`}
//                   onClick={() => {
//                     handleFilterClick({ field: "sale", value: "true" });
//                     handleFilterClickst({
//                       field: "sale",
//                       value: "true",
//                     });
//                   }}
//                 ></div>
//                 Акція
//               </li>{" "}
//               <li className="ulFirstfilterLi">
//                 <div
//                   className={`blockCheckFilterJoin ${
//                     filters.some(
//                       (selectedFilter) =>
//                         selectedFilter.field === "rozprodaz" &&
//                         selectedFilter.value === "true"
//                     )
//                       ? "selected"
//                       : ""
//                   }`}
//                   onClick={() => {
//                     handleFilterClick({ field: "rozprodaz", value: "true" });
//                     handleFilterClickst({
//                       field: "rozprodaz",
//                       value: "true",
//                     });
//                   }}
//                 ></div>
//                 Розпродаж
//               </li>
//             </ul>
//           </div>

//           {objFilter.map((el, index) => {
//             return (
//               <div className="secondBlockWrapFilterProd" key={index}>
//                 <p className="secondBlockWrapFilterProdP">{el.name}</p>
//                 <ul className="ulSecondfilter">
//                   {el.list.map((value, index) => {
//                     const filter = { field: el.transliter, value: value };
//                     return (
//                       <li
//                         onClick={() => {
//                           handleFilterClick(filter);
//                           handleFilterClickst(filter);
//                         }}
//                         className="ulSecondfilterLi"
//                         key={index}
//                       >
//                         <div
//                           className={`blockCheckFilterJoin ${
//                             selectedFilters.some(
//                               (selectedFilter) =>
//                                 selectedFilter.field === filter.field &&
//                                 selectedFilter.value === filter.value
//                             )
//                               ? "selected"
//                               : ""
//                           }`}
//                         ></div>
//                         {value}
//                       </li>
//                     );
//                   })}
//                 </ul>
//               </div>
//             );
//           })}

//           {windowDimensions && (
//             <>
//               <div className="twoButtonAllWrap">
//                 {/* <div className="buttonAllBooksFilter" onClick={allBooksClose}>
//                   Усі книги
//                 </div> */}{" "}
//                 <div className="buttonWatch" onClick={closeMenu}>
//                   Дивитися
//                 </div>
//                 <div
//                   className="buttonAllBooksFilter"
//                   onClick={() => setSelectedFilters([])}
//                 >
//                   Скинути
//                 </div>
//               </div>
//               <div className="oneButtonAllWrap"></div>
//             </>
//           )}
//           {!windowDimensions && (
//             <>
//               <div className="wrapbuttonInMobile">
//                 <div className="buttonAllBooksFilter" onClick={allBooksClose}>
//                   Усі книги
//                 </div>
//                 <div
//                   className="buttonAllBooksFilter"
//                   onClick={() => setSelectedFilters([])}
//                 >
//                   Скинути
//                 </div>
//                 <div className="buttonWatch" onClick={closeMenu}>
//                   Дивитися
//                 </div>
//               </div>
//             </>
//           )}
//         </div>
//       )}
//     </>
//   );
// }

import { useState, useRef, useEffect } from "react";
import { useSelector, useDispatch } from "react-redux";
import {
  fetchProductsAll,
  fetchProducts,
  clearSearchResults,
} from "../../../function/productsSlice";
import {
  addFilter,
  removeFilter,
  clearFilters,
} from "../../../function/filtersSlice";
import { auth, db } from "../../../firebase";
import { query, getDocs, collection } from "firebase/firestore";
import { Link, useNavigate } from "react-router-dom";

export default function FilterMenu({
  windowDimensions,
  setAllBooks,
  allBooks,
  setIsBooksFilterActive,
}) {
  const [selectedFilters, setSelectedFilters] = useState([]);
  const [objFilter, setObjFilter] = useState([]);
  const dispatch = useDispatch();
  const navigate = useNavigate();
  const menuRef = useRef(null); // Ref для меню
  const filters = useSelector((state) => state.filters);
  useEffect(() => {
    const fetchFilters = async () => {
      const querySnapshot = await getDocs(collection(db, "filters"));
      const loadedFilters = querySnapshot.docs.map((doc) => doc.data());
      setObjFilter(loadedFilters);
    };
    fetchFilters();
  }, []);

  useEffect(() => {
    dispatch(fetchProducts(filters));
  }, [filters]);
  const normalizeValueToString = (val) => {
    if (val === true) return "true";
    if (val === false) return "false";
    return String(val);
  };
  // const handleFilterClickst = (filter) => {
  //   const normalizedFilter = {
  //     ...filter,
  //     value: filter.value === "true" ? true : filter.value,
  //   };

  //   setSelectedFilters((prevFilters) => {
  //     const index = prevFilters.findIndex(
  //       (selectedFilter) =>
  //         selectedFilter.field === normalizedFilter.field &&
  //         selectedFilter.value === normalizedFilter.value
  //     );

  //     if (index === -1) {
  //       return [...prevFilters, normalizedFilter];
  //     } else {
  //       return [
  //         ...prevFilters.slice(0, index),
  //         ...prevFilters.slice(index + 1),
  //       ];
  //     }
  //   });
  // };
  const handleFilterClickst = (filter) => {
    const normalizedFilter = {
      ...filter,
      value: normalizeValueToString(filter.value),
    };

    setSelectedFilters((prevFilters) => {
      const index = prevFilters.findIndex(
        (selectedFilter) =>
          selectedFilter.field === normalizedFilter.field &&
          selectedFilter.value === normalizedFilter.value
      );

      if (index === -1) {
        return [...prevFilters, normalizedFilter];
      } else {
        return [
          ...prevFilters.slice(0, index),
          ...prevFilters.slice(index + 1),
        ];
      }
    });
  };

  // const handleFilterClick = (filter) => {
  //   if (
  //     filters.some(
  //       (selectedFilter) =>
  //         selectedFilter.field === filter.field &&
  //         selectedFilter.value === filter.value
  //     )
  //   ) {
  //     dispatch(removeFilter(filter));
  //   } else {
  //     dispatch(addFilter(filter));
  //   }
  // };
  // const handleFilterClick = (filter) => {
  //   const normalizedFilter = {
  //     ...filter,
  //     value: filter.value === "true" ? true : filter.value,
  //   };

  //   if (
  //     filters.some(
  //       (selectedFilter) =>
  //         selectedFilter.field === normalizedFilter.field &&
  //         selectedFilter.value === normalizedFilter.value
  //     )
  //   ) {
  //     dispatch(removeFilter(normalizedFilter));
  //   } else {
  //     dispatch(addFilter(normalizedFilter));
  //   }
  // };
  const handleFilterClick = (filter) => {
    if (
      filters.some(
        (selectedFilter) =>
          selectedFilter.field === filter.field &&
          selectedFilter.value === filter.value
      )
    ) {
      dispatch(removeFilter(filter));
    } else {
      dispatch(addFilter(filter));
    }
  };

  const closeMenu = () => {
    setAllBooks(false);
    navigate("/catalog");
  };

  const allBooksClose = () => {
    dispatch(clearSearchResults());
    dispatch(fetchProductsAll());
    setAllBooks(false);
    navigate("/catalog");
  };

  // Функція для обробки кліку поза меню
  const handleClickOutside = (event) => {
    if (menuRef.current && !menuRef.current.contains(event.target)) {
      setAllBooks(false);
      setIsBooksFilterActive(false);
    }
  };

  useEffect(() => {
    // Додаємо слухач кліків по документу
    document.addEventListener("mousedown", handleClickOutside);
    return () => {
      // Очищуємо слухач кліків при демонтажі компонента
      document.removeEventListener("mousedown", handleClickOutside);
    };
  }, []);

  return (
    <>
      {objFilter && (
        <div className="filterMenuWrapHeadr" ref={menuRef}>
          <div className="secondBlockWrapFilterProd">
            <ul className="ulFirstfilter">
              <li className="ulFirstfilterLi">
                <div
                  className={`blockCheckFilterJoin ${
                    filters.some(
                      (selectedFilter) =>
                        selectedFilter.field === "predprodag" &&
                        selectedFilter.value === "true"
                    )
                      ? "selected"
                      : ""
                  }`}
                  onClick={() => {
                    handleFilterClick({ field: "predprodag", value: "true" });
                    handleFilterClickst({ field: "predprodag", value: "true" });
                  }}
                ></div>
                Передпродаж
              </li>
              <li className="ulFirstfilterLi">
                <div
                  className={`blockCheckFilterJoin ${
                    filters.some(
                      (selectedFilter) =>
                        selectedFilter.field === "isNew" &&
                        selectedFilter.value === "true"
                    )
                      ? "selected"
                      : ""
                  }`}
                  onClick={() => {
                    handleFilterClick({ field: "isNew", value: "true" });
                    handleFilterClickst({ field: "isNew", value: "true" });
                  }}
                ></div>
                Новинка
              </li>
              <li className="ulFirstfilterLi">
                <div
                  className={`blockCheckFilterJoin ${
                    filters.some(
                      (selectedFilter) =>
                        selectedFilter.field === "sale" &&
                        selectedFilter.value === "true"
                    )
                      ? "selected"
                      : ""
                  }`}
                  onClick={() => {
                    handleFilterClick({ field: "sale", value: "true" });
                    handleFilterClickst({
                      field: "sale",
                      value: "true",
                    });
                  }}
                ></div>
                Акція
              </li>{" "}
              <li className="ulFirstfilterLi">
                <div
                  className={`blockCheckFilterJoin ${
                    filters.some(
                      (selectedFilter) =>
                        selectedFilter.field === "rozprodaz" &&
                        selectedFilter.value === "true"
                    )
                      ? "selected"
                      : ""
                  }`}
                  onClick={() => {
                    handleFilterClick({ field: "rozprodaz", value: "true" });
                    handleFilterClickst({
                      field: "rozprodaz",
                      value: "true",
                    });
                  }}
                ></div>
                Розпродаж
              </li>
            </ul>
          </div>

          {objFilter.map((el, index) => {
            return (
              <div className="secondBlockWrapFilterProd" key={index}>
                <p className="secondBlockWrapFilterProdP">{el.name}</p>
                <ul className="ulSecondfilter">
                  {el.list.map((value, index) => {
                    const filter = { field: el.transliter, value: value };
                    const isSelected = filters.some(
                      (selectedFilter) =>
                        selectedFilter.field === filter.field &&
                        selectedFilter.value === filter.value
                    );
                    return (
                      <li
                        onClick={() => handleFilterClick(filter)}
                        className="ulSecondfilterLi"
                        key={index}
                      >
                        <div
                          className={`blockCheckFilterJoin ${
                            isSelected ? "selected" : ""
                          }`}
                        ></div>
                        {value}
                      </li>
                    );
                  })}
                </ul>
              </div>
            );
          })}

          {windowDimensions && (
            <>
              <div className="twoButtonAllWrap">
                {/* <div className="buttonAllBooksFilter" onClick={allBooksClose}>
                  Усі книги
                </div> */}{" "}
                <div className="buttonWatch" onClick={closeMenu}>
                  Дивитися
                </div>
                <div
                  className="buttonAllBooksFilter"
                  onClick={() => dispatch(clearFilters())}
                >
                  Скинути
                </div>
              </div>
              <div className="oneButtonAllWrap"></div>
            </>
          )}
          {!windowDimensions && (
            <>
              <div className="wrapbuttonInMobile">
                <div className="buttonAllBooksFilter" onClick={allBooksClose}>
                  Усі книги
                </div>
                <div
                  className="buttonAllBooksFilter"
                  onClick={() => dispatch(clearFilters())}
                >
                  Скинути
                </div>
                <div className="buttonWatch" onClick={closeMenu}>
                  Дивитися
                </div>
              </div>
            </>
          )}
        </div>
      )}
    </>
  );
}
